<script>
export default {
    props: ['view'],
    // data() {
    //     return {
    //         view: 'table'
    //     };
    // },
    computed: {
        description() {
            if (this.view == 'columns') {
                return 'If you want a fully visual representation of your projects, and tasks, then be sure to opt for the Columns (Kanban) view. You’ll be able to navigate your boards quickly and with ease.';
            } else if (this.view == 'table') {
                return 'If you’re used to working in Google Sheets or Excel, or simply want a view that’s easy to scan, then the Table view is perfect for you. You’ll get to see all attributes and tasks at a glance.';
            } else if (this.view == 'list') {
                return 'The List view is ideal for anyone who wants a simple overview of their tasks in one place. It’s also a great way to create to-do lists and tick off tasks as you complete them.';
            } else if (this.view == 'gantt') {
                return 'If you’re dealing with long-term projects and need to visualize your timeline for all of them, then we recommend the Gantt view. A great solution for product roadmaps, project planning, etc.';
            } else if (this.view == 'calendar') {
                return 'The Calendar view will allow you to easily manage all calls, meetings, events, and other time-sensitive items. When creating a calendar, you get monthly, weekly and daily item overviews.';
            } else if (this.view == 'form') {
                return 'Need to create a contact or lead generation form? With the Form view, you can create custom forms in Infinity and share them with anyone either via a public link or by using the embed code. ';
            }
			
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/frontend/components/FeaturesViews.vue